import React from "react";
import "./ProjectCard.css";
import { Fade } from "react-reveal";

export default function ProjectCard({ pub, theme }) {
  return (
    <Fade bottom duration={2000} distance="40px">
      <a
        className="project-card-div"
        href={pub.url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ backgroundColor: theme.highlight }}
      >
        <div className="project-name-div">
          <p className="project-name" style={{ color: theme.text }}>
            {pub.name}
          </p>
        </div>
        <p className="project-description" style={{ color: theme.text }}>
          {pub.description}
        </p>
        <div className="project-details">
          <p
            className="project-creation-date subTitle"
            style={{ color: theme.secondaryText }}
          >
            {pub.createdAt.split("T")[0]}
          </p>
          <span className="project-link-arrow" style={{ color: theme.text }}>
            &rarr;
          </span>
        </div>
      </a>
    </Fade>
  );
}
